/**
 * Vendored from AudioCN (https://github.com/audiocn/ui), hand-copied at
 * commit 42f863ec333c6912c421d1e9d6d7ce7850ce2680.
 * Source file: lib/audio/bands.ts
 * License: MIT, Copyright (c) 2026 OrcDev. See components/ui/audiocn/LICENSE.md.
 * Local changes:
 *   - kept resampleLevels() only; the spectrum band helpers are not used here
 */
/**
 * Fits `length` values from a ring buffer, starting at `start`, into
 * `out.length` values. Each output takes the loudest value in its span.
 */
export const resampleLevels = (
  source: ArrayLike<number>,
  start: number,
  length: number,
  out: Float32Array
): Float32Array => {
  const size = source.length;
  const count = out.length;

  if (size === 0 || length <= 0 || count === 0) {
    out.fill(0);
    return out;
  }

  for (let index = 0; index < count; index += 1) {
    const from = Math.floor((index * length) / count);
    const to = Math.max(from + 1, Math.floor(((index + 1) * length) / count));
    let loudest = 0;
    for (let offset = from; offset < to; offset += 1) {
      const value = source[(start + offset) % size] ?? 0;
      if (value > loudest) {
        loudest = value;
      }
    }
    out[index] = loudest;
  }
  return out;
};
